import { useEffect, useState } from "react";

import { addToCache, avatarCache } from "../shared/avatarCache";

// This hook is used to preload images before rendering the component
const usePreloadImages = (urls: string[] | null, isLoading: boolean) => {
	const [imagesLoaded, setImagesLoaded] = useState(false);

	useEffect(() => {
		if (!isLoading && urls) {
			if (urls.length > 0) {
				const imagesToLoad = urls.filter((url) => !(url in avatarCache) || url === null);
				if (imagesToLoad.length > 0) {
					setImagesLoaded(false);
					preloadImages(imagesToLoad);
				} else {
					setImagesLoaded(true);
				}
			} else {
				setImagesLoaded(true);
			}
		}
	}, [urls, isLoading]);

	const preloadImages = (imageUrls) => {
		let loadedCount = 0;
		const imagesToload = imageUrls;
		imagesToload.forEach((url) => {
			const img = new Image();
			img.onload = () => {
				loadedCount++;
				addToCache(url, img);
				if (loadedCount === imagesToload.length) {
					setImagesLoaded(true);
				}
			};
			img.onerror = () => {
				loadedCount++;
				if (loadedCount === imagesToload.length) {
					setImagesLoaded(true);
				}
			};
			img.src = url;
			img.crossOrigin = "Anonymous";
		});
	};
	// Urls can be null if the component is not ready to load the images
	return { imagesLoaded: urls === null ? false : imagesLoaded };
};

export default usePreloadImages;
